<template>
  <div class="to-login-page">
    <div class="main-content">
      <div class="inbetweening">
        <img src="../assets/toLoginPage.png">
      </div>
      <div class="link">
        <div class="title">
          请选择您需要的登录方式：
        </div>
        <div class="btn">
          <div>
            <el-button type="primary" plain @click="toOA">
              前往OA登录
            </el-button>
          </div>
          <div>
            <el-button type="primary" plain @click="toTrench">
              前往渠道登录
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToLoginPage',
  beforeRouteEnter (to, from, next) {
    if (to.query.union_session_ticket) {
      localStorage.setItem('union_session_ticket', to.query.union_session_ticket);
      localStorage.setItem('loginType', to.query.loginType || '');
      if (to.query.loginFrom) {
        localStorage.setItem('loginFrom', to.query.loginFrom);
      }
      next('/');
    }
    localStorage.setItem('loginType', to.query.loginType || '');
    if (to.query.loginFrom) {
      localStorage.setItem('loginFrom', to.query.loginFrom);
    }
    next();
  },
  methods: {
    toOA () {
      localStorage.setItem('loginFrom', 'oa');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `https://web-e-gw.ruijie.com.cn/api/union-session/login/c0c73417cf58cb87e146a78f6e44ef44?type=sid&reurl=${
          window.location.origin + '/toLoginPage'
        }`;
      } else {
        window.location.href = `https://web-e-gw.ruijie.com.cn/api/union-session/login/c0c73417cf58cb87e146a78f6e44ef44?type=sid&reurl=${
          window.location.origin + '/toLoginPage'
        }`;
      }
    },
    toTrench () {
      localStorage.setItem('loginFrom', 'channel');
      // let URL = window.location.href;
      // URL = URL.substring(0, URL.indexOf(location.pathname));
      // window.location.href = `http://partners.ruijie.com.cn/LayerPartnerLogin.aspx?URL=${URL}`;
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `http://partners.ruijie.com.cn/LayerPartnerLogin.aspx?URL=http://cesuat.ruijie.com.cn/`;
      } else {
        window.location.href = `http://partners.ruijie.com.cn/LayerPartnerLogin.aspx?URL=https://ces.ruijie.com.cn/`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.to-login-page{
  background: #FFFFFF;
  width: 100%;
  height: 100%;
  position: relative;
  .main-content{
    position: absolute;
    left: 50%;
    margin-left: -325px;
    top: 50%;
    margin-top: -200px;
    width: 650px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    height: 400px;
    box-shadow:0 0 20px #C9E9F2;
    .inbetweening{
      img{
        height: 400px;
      }
    }
    .link{
      position: relative;
      width: 42%;
      .title{
        position: absolute;
        left: 0;
        top: 80px;
        font-size: 18px;
        text-align: left;
      }
      .btn{
        position: absolute;
        left: 0;
        top: 140px;
        .el-button{
          width: 200px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
